"use client";
import Image from "next/image";

interface Banner {
  src: string;
  width: number;
  height: number;
}

export function BrandBanner({ banner }: { banner: Banner }) {
  return (
    <div className="relative w-full">
      <Image
        src={banner.src}
        alt="brand banner"
        width={banner.width}
        height={banner.height}
        className="w-full h-auto"
        priority
      />
    </div>
  );
}
